export enum AMPM {
  AM = 'AM',

  PM = 'PM',
}
